import { render } from "./Soon.vue?vue&type=template&id=f5c0bac6"
import script from "./Soon.vue?vue&type=script&lang=js"
export * from "./Soon.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\bigSis_vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__